"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCustomerResultWithPhoneBookAllOfToJSON = exports.ChangeCustomerResultWithPhoneBookAllOfFromJSONTyped = exports.ChangeCustomerResultWithPhoneBookAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChangeCustomerResultWithPhoneBookAllOfFromJSON(json) {
    return ChangeCustomerResultWithPhoneBookAllOfFromJSONTyped(json, false);
}
exports.ChangeCustomerResultWithPhoneBookAllOfFromJSON = ChangeCustomerResultWithPhoneBookAllOfFromJSON;
function ChangeCustomerResultWithPhoneBookAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'phoneBook': !(0, runtime_1.exists)(json, 'phoneBook') ? undefined : (json['phoneBook'].map(_1.PhoneNumberWithTypeFromJSON)),
    };
}
exports.ChangeCustomerResultWithPhoneBookAllOfFromJSONTyped = ChangeCustomerResultWithPhoneBookAllOfFromJSONTyped;
function ChangeCustomerResultWithPhoneBookAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'phoneBook': value.phoneBook === undefined ? undefined : (value.phoneBook.map(_1.PhoneNumberWithTypeToJSON)),
    };
}
exports.ChangeCustomerResultWithPhoneBookAllOfToJSON = ChangeCustomerResultWithPhoneBookAllOfToJSON;
//# sourceMappingURL=ChangeCustomerResultWithPhoneBookAllOf.js.map